// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customIconWidth[data-v-2c306d96]{\n  width: 16px;\n  height: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
